module.exports = __webpack_public_path__ + "static/media/jaehyun-1.jpeg";